module.exports = ".wifi-off{\n  color: red;\n}\n.wifi-on{\n  color: green;\n}\n\n"